// lenis-scroll.js
if (!window.lenis_initiated) {
  window.lenis_initiated = true;

  document.documentElement.style.scrollBehavior = 'auto';

  function initLenis() {
    if (window.lenis_instance) return;

    if (typeof Lenis !== 'undefined') {
      const main = document.querySelector('#MainContent') || document.documentElement;

      const lenis = new Lenis({
        wrapper: main,
        content: main.querySelector('main') || main,
        duration: 1.25,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
        smoothTouch: false,
      });

      window.lenis_instance = lenis;

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);
    }
  }

  document.addEventListener('DOMContentLoaded', initLenis);
  document.addEventListener('shopify:section:load', initLenis);
}
